import Vue from 'vue'

import uiGroupValidator from './src/ui-group-validator.vue';

Vue.component('ui-group-validator', uiGroupValidator);

export default uiGroupValidator;



//////////////////
// WEBPACK FOOTER
// ./~/ui-group-validator/index.js
// module id = 549
// module chunks = 0